import { useEffect, useRef } from "react";
import { TransportTicketFields } from "../../interface/api/TransportTicketFields";
import { Truck } from "../../interface/api/Truck";

const LicensePlateAutoLookup = <T extends TransportTicketFields>({
  ticket,
  setTicket,
  trucks,
}: {
  ticket: T;
  setTicket: (t: T) => void;
  trucks: Truck[];
}) => {
  const mountedRef = useRef(false);

  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }
    if (!ticket.truckLicensePlate) return;
    const plate = ticket.truckLicensePlate;
    if (plate.includes("_") || plate.length < 7) return;

    const match = trucks.find(
      (t) =>
        t.licensePlate &&
        t.licensePlate.replace(/\s/g, "").toLocaleLowerCase() ===
          plate.replace(/\s/g, "").toLocaleLowerCase()
    );
    if (match) {
      setTicket({
        ...ticket,
        truckNumber: match.number,
        transportCompanyId: match.transportCompanyId,
        transportCompanyName: match.transportCompanyName,
        haulageCompanyName: match.transportCompanyName,
        truckId: match.id,
        truckDriverName: match.driverName || ticket.truckDriverName,
      });
    }
  }, [ticket.truckLicensePlate]);

  return null;
};

export default LicensePlateAutoLookup;
